<div [class.border-danger]="sumTotal() > maxBudget" class="border border-secondary my-3 ml-4 w-95 p-3" align="center">

  <h4>Total budget for all funding requests:</h4>
  <h3 [class.text-danger]="sumTotal() > maxBudget">R {{sumTotal() | number: '1.0-0'}}</h3>
  <p *ngIf="sumTotal() > maxBudget" class="text-danger">Reminder: the maximum funding request is {{maxBudget}}</p>

</div>
